export const SimulationTypePurchase = 1;
export const SimulationTypeRefund = 2;
export const SimulationTypeCancel = 3;
export const SimulationTypeReversal = 4;
export const SimulationTypeTxnStatus = 5;
export const SimulationTypeLinkTerminal = 6;
export const SimulationTypeUnLinkTerminal = 7;